/**
 * Helper function that generates media queries based on breakpoint, e.g.
 * getMediaQuery(720) => '@media screen and (min-width: 720px)'
 */
export var getMediaQuery = function (breakpoint) {
    return "@media screen and (min-width: ".concat(breakpoint, "px)");
};
export var getMediaQueries = function (breakpoints) {
    return Object.keys(breakpoints)
        .map(function (key) { return breakpoints[key]; })
        .sort(function (a, b) { return a - b; })
        .map(getMediaQuery);
};
// export const getMediaQueryPageMargins = (theme: Theme): MediaQueryPageMargins => {
//   const result = {} as MediaQueryPageMargins;
//   const mediaQueries = getMediaQueries(theme.breakpoints);
//
//   // Helper function to calculate the margin for each breakpoint
//   const calculateMargin = (index: number): number => {
//     if (Array.isArray(theme.grid.margins)) {
//       // Use the index directly if it exists or access the last element using length - 1
//       const lastIndex = theme.grid.margins.length - 1;
//       return theme.grid.margins[index] ?? theme.grid.margins[lastIndex];
//     }
//     return theme.grid.margins;
//   };
//
//   // Using forEach to iterate over the mediaQueries array
//   mediaQueries.forEach((query, index) => {
//     const margin = calculateMargin(index);
//     result[query] = { paddingInlineStart: `${margin}px`, paddingInlineEnd: `${margin}px` };
//   });
//
//   return result;
// };
